import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
    <title>Logo</title>
    <g transform="translate(-8.000000, -2.000000)">
      <g transform="translate(11.000000, 5.000000)">
        <path
          d="M 25.5417 61 L 37.116699999999994 30.3 L 42.116699999999994 30.3 L 53.6917 61 L 48.6917 61 L 45.29837752442997 52 L 33.93502247557003 52 L 30.5417 61 Z M 35.82020162866449 47 L 43.413198371335504 47 L 37.49373583061889 31.3 L 41.7396641693811 31.3 Z"
          fill="currentColor"
        />
        <polygon
          id="Shape"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="39 0 0 22 0 67 39 90 78 68 78 23"
        />
      </g>
    </g>
  </svg>
);

export default IconLogo;
